import React, { useState } from 'react';
import './WelcomeModal.css';

const WelcomeModal = ({ onRegister }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('Please enter your name');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Simulate a small delay for better UX
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Create a simple user object with the entered name
      const user = {
        id: Date.now(), // Simple ID generation
        name: name.trim(),
        registeredAt: new Date().toISOString()
      };
      
      // Store in localStorage for persistence
      localStorage.setItem('signcrypt_user', JSON.stringify(user));
      
      // Call the onRegister callback
      onRegister(user);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="welcome-modal">
      <div className="welcome-modal-content">
        <div className="welcome-header">
          <h1>SignCrypt</h1>
          <p>Your inclusive communication platform</p>
        </div>

        <div className="welcome-body">
          <p>Please enter your name to get started:</p>
          
          <form onSubmit={handleSubmit} className="welcome-form">
            <div className="form-group">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your name"
                className="name-input"
                disabled={loading}
                autoFocus
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button 
              type="submit" 
              className="btn btn-primary welcome-btn"
              disabled={loading}
            >
              {loading ? 'Setting up...' : 'Get Started'}
            </button>
          </form>
        </div>

        <div className="welcome-features">
          <div className="feature">
            <span className="feature-icon">🤟</span>
            <span>Sign Language Recognition</span>
          </div>
          <div className="feature">
            <span className="feature-icon">📡</span>
            <span>Morse Code Detection</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🔒</span>
            <span>Encrypted Messaging</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🚨</span>
            <span>Emergency SOS</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal; 